import { Link } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import {connect} from "react-redux"
import {Component} from "react"
import {isPublicUser} from "shared/plans"

class UpgradePlan extends Component {
  render(){
    const publicPlan = isPublicUser(this.props.current_user)
    return (
      <Container className='pt-4'>
        <Row>
          <Col md={{ span: 8, offset: 2 }}>
            <Card>
              <Card.Body>
                <Card.Title className="text-info"><i className="fas fa-info-circle mr-1"></i>{publicPlan ? 'Please login' : 'Upgrade your plan'}</Card.Title>
                <Card.Text>
                  {publicPlan ? 'Please login or sign up to access this feature.': 'Please upgrade your plan in order to access this feature.'}
                </Card.Text>
                {publicPlan ? <a onClick={()=> window.location=window.location.origin+'/users/sign_in'} className="btn btn-primary">Login</a> :
                  <Link to="/settings?tab=subscription" className="btn btn-primary">Upgrade</Link>
                }
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    )
  }
}

function mapStateToProps(state) {
  const { users } = state;

  return {
    current_user: users.user
  }
}

export default connect(mapStateToProps, null)(UpgradePlan)
